import { useState } from "react";
import OperacionesModificarMotivoLiquidacion from "./OperacionesModificarMotivoLiquidacion";

function SolicitudModificarMotivoLiquidacion({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
  motivosLiquidacion
}) {
  const [datosSolicitudLocal, setDatosSolicitudLocal] = useState({
    operaciones: datosSolicitud.operaciones,
  });



  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosSolicitudLocal,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setDatosSolicitudLocal(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }

  return (
    <>
      <OperacionesModificarMotivoLiquidacion
        motivosLiquidacion={ motivosLiquidacion}
        operaciones={datosSolicitudLocal.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEditar="true"
        permiteEliminar="true"
      />
    </>
  );
}

export default SolicitudModificarMotivoLiquidacion;
